import LabeledDateInput from "components/labeledInput/LabeledDateInput";
import { formikConnect } from "utils/formikConnect";

export default formikConnect(LabeledDateInput);
